import { defineRecipe } from "@chakra-ui/react";


export const pressableButtonRecipe = defineRecipe({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transform: "translateY(0)",
    gap: "0.5rem",
    borderRadius: "pill",
    fontFamily: "display",
    fontWeight: "700",
    lineHeight: "1",
    userSelect: "none",
    whiteSpace: "nowrap",
    transitionProperty: "transform, box-shadow, background-color, color, border-color",
    transitionDuration: "120ms",
    _focusVisible: {
      outline: "2px solid",
      outlineColor: "colorPalette.400",
      outlineOffset: "2px",
    },
    _disabled: {
      opacity: 0.55,
      cursor: "not-allowed",
      transform: "none",
      boxShadow: "none",
      pointerEvents: "none",
    },
  },
  variants: {
    variant: {
      solid: {},
      outline: {},
      surface: {},
      ghost: {},
      disabled: {},
    },
    size: {
      sm: {
        h: "9",
        px: "4",
        fontSize: "sm",
      },
      md: {
        h: "11",
        px: "6",
        fontSize: "sm",
      },
      lg: {
        h: "14",
        px: "8",
        fontSize: "md",
      },
    },
  },
  defaultVariants: {
    variant: "solid",
    size: "md",
  },
});
